@for (question of selectedSampleQuestions; track question) {
  <div class="d-flex flex-wrap gap-3 mb-3">
    <button
      ds-button
      class="sample-question"
      [variant]="DsButtonVariants.secondary"
      [intent]="DsButtonIntent.ai"
      [short]="true"
      [disabled]="isDisabled"
      (click)="onQuestionClick(question)"
    >
      {{ question }}
    </button>
  </div>
}
